import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { MypageClientHotlinePage } from '@/feature/mypage/hotline/page/MypageClientHotlinePage';
/**
 * クライアントマイページ ホットラインタブ表示
 */
export const MypageClientHotline = () => _jsx(MypageClientHotlinePage, {});
